import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getTripsListService = (params = {}) => {
  return api.get(url.GET_ALL_TRIPS, params);
};

export const getTripsBillChargedService = (params = {}) => {
  return api.get(url.GET_ALL_TRIPS_BILL_CHARGED, params);
};

export const addBookedTripService = (requestParams = {}) => {
  return api.create(url.POST_BOOKED_TRIP, requestParams);
};

export const deleteBookedTripService = (id) => {
  return api.delete(url.DELETE_BOOKED_TRIP(id));
};

export const editBookedTripService = (queryParams) => {
  return api.create(url.PUT_BOOKED_TRIP, queryParams);
};

// export const getCategoryByIdService=(id)=>{
//   return api.get(url.GET_MEAL_CATEGORY(id));
// }
